<template>
    <div class="band-search">
        <div v-if="searchState == 'searching'">
            <div class="overlay"></div>
            <div class="form-sending"></div>
        </div>
        <div class="row no-gutters" v-bind:class="{ 'align-items-start' : showAdvanced }">
            <div class="col-lg-9">
                <div class="row h-100">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Milloin?</label>
                            <datepicker
                                :value="selectedDate"
                                placeholder="Tapahtuman päivämäärä"
                                format="dd.MM.yyyy"
                                :monday-first="true"
                                @selected="onDatepickerSelect"
                                :disabled-dates="disabledDates">
                            </datepicker>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <city-field
                            :city-options=cityOptions
                            v-model="selectedCity">
                        </city-field>
                    </div>
                    <div class="col-md-3">
                        <crowd-field
                            :crowd-options=crowdOptions
                            v-model="selectedCrowd">
                        </crowd-field>
                    </div>
                    <div class="col-md-3">
                        <audience-field-drop-down
                            :audience-options=audienceOptions
                            v-model="selectedAudience">
                        </audience-field-drop-down>
                    </div>
                </div>
                <div class="row mt-4" v-if="showAdvanced">
                    <div class="col-md-3 justify-content-start">
                        <song-type-field
                            :song-type-options=songTypeOptions
                            v-model="selectedSongType">
                        </song-type-field>
                    </div>
                    <div class="col-md-3 justify-content-start">
                        <band-type-field
                            :band-type-options=bandTypeOptions
                            v-model="selectedBandType">
                        </band-type-field>
                    </div>

                    <div class="col-md-6 justify-content-start">
                        <genre-fields
                            :items=genreOptions
                            v-model="selectedGenres">
                        </genre-fields>
                    </div>
                </div>
            </div>
            <div class="call-to-action__container col-lg-3 align-items-center align-items-lg-end">
                <a :href="searchUrl" class="btn btn--call-to-action" @click="startSearch" v-bind:class="buttonClass">Näytä bändit</a>
            </div>
        </div>
        <div v-if="isAdvancedSearchVisible" class="row mt-4">
            <div class="col-md-12">
                <a class="band-search__show-advanced-search" v-on:click='showAdvanced = !showAdvanced'><i class="fa fa-search"> </i> Tarkennettu haku</a>
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';
    import CrowdField from './CrowdField';
    import CityField from './CityField';
    import SongTypeField from './SongTypeField';
    import BandTypeField from './BandTypeField';
    import GenreFields from './GenreFields';
    import ApiCall from '../modules/ApiCall';
    import FormData from '../modules/FormData';
    import Routes from '../modules/Routes';
    import Messages from '../modules/Messages';
    import AudienceFieldDropDown from './AudienceFieldDropDown';

    export default {
        components: {
            Datepicker,
            CrowdField,
            CityField,
            AudienceFieldDropDown,
            SongTypeField,
            BandTypeField,
            GenreFields
        },
        mounted() {
            ApiCall.getCached(Routes.generate('_public_api_options_base_data'), true).then((formData) => {
                this.cityOptions = formData.cities;
                this.audienceOptions = formData.audiences;
                this.crowdOptions = formData.crowds;
                this.songTypeOptions = formData.songTypes;
                this.bandTypeOptions = formData.bandTypes;
                this.genreOptions = formData.genres;
            });
            if (this.initialErrors.length > 0) {
                Messages.plainTextError('Hupsista, nyt meni jotain pieleen :(');
            }
        },
        props: {
            heading: {
                type: String,
                default: 'Aloita valitsemalla haluamasi päivämäärä keikalle sekä keikkapaikkunta'
            },
            initialShowAdvanced: {
                type: Boolean,
                default: false
            },
            initialDate: {
                type: String
            },
            initialAudience: {
                type: Object
            },
            initialCity: {
                type: Object
            },
            initialSongType: {
                type: Object
            },
            initialBandType: {
                type: Object
            },
            initialCrowd: {
                type: Object
            },
            initialErrors: {
                type: Array,
                default: () => { return []; }
            },
            initialGenres: {
                type: Array,
                default: () => { return []; }
            },
            isAdvancedSearchVisible: {
              type: Boolean,
              default: false,
              required: false,
            }
        },
        computed: {
            searchUrl() {
                if (this.isReadyForSearch()) {
                    return new FormData(this.$data).parseSearchData();
                }

                return '';
            },
            buttonClass() {
                if (!this.isReadyForSearch()) {
                    return 'btn--not-active';
                }

                return '';
            },
        },
        data() {
            return {
                selectedCity: this.initialCity,
                selectedCrowd: this.initialCrowd,
                selectedAudience: this.initialAudience,
                selectedSongType: this.initialSongType,
                selectedBandType: this.initialBandType,
                selectedDate: moment(this.initialDate).toDate(),
                selectedGenres: this.initialGenres,
                cityOptions: [],
                crowdOptions: [],
                audienceOptions: [],
                songTypeOptions: [],
                bandTypeOptions: [],
                genreOptions: [],
                searchState: 'not-started',
                showAdvanced: this.initialShowAdvanced,
                disabledDates: { to: moment().add(2, 'days').toDate() },
                messages: {
                    errors: [],
                    successes: [],
                    warnings: [],
                    error: '',
                    success: '',
                    warning: '',
                }
            };
        },
        methods: {
            onDatepickerSelect(selectedDate) {
                this.selectedDate = selectedDate;
            },
            isReadyForSearch() {
                if (
                    !this.selectedDate
                    || !this.selectedCity
                    || !this.selectedCity.id
                ) {
                    return false;
                }

                return true;
            },
            startSearch() {
                this.searchState = 'searching';
            }
        }
    };
</script>
